const SECTION_LABEL_KEYS: Record<string, string> = {
  inbox: "app.nav.inbox",
  "post-comments": "app.nav.postComments",
  contacts: "app.nav.contacts",
  campaigns: "app.nav.campaigns",
  reports: "app.nav.reports",
  channels: "app.nav.channels",
  settings: "app.nav.settings",
  "super-admin": "superAdmin.badge",
};

/** Existing page-label key for the browser tab, or null for routes titled by the product name alone. */
export function documentTitleLabelKey(pathname: string): string | null {
  if (pathname === "/settings/team" || pathname.startsWith("/settings/team/")) {
    return "app.account.team";
  }
  const section = pathname.split("/")[1] ?? "";
  return SECTION_LABEL_KEYS[section] ?? null;
}

export function formatDocumentTitle(pageLabel: string | null, appName: string): string {
  return pageLabel ? `${pageLabel} · ${appName}` : appName;
}
